import React from 'react';

interface IProps {
  className?: string;
}

export const SeeAllCard: React.FC<IProps> = ({ className }) => (
  <div
    className={`flex h-[368px] w-40 min-w-40 cursor-pointer flex-col items-center justify-center gap-5 rounded-lg  bg-jackfruit-300 ${className}`}>
    <div className='flex size-10 items-center justify-center rounded-full border border-neutral-100'>
      <i className='fas fa-arrow-right text-base text-neutral-800' />
    </div>
    <span className='text-center text-xl font-bold text-neutral-800'>See all</span>
  </div>
);
